/**
 * Parses a structured idea text into an object containing type, headline, transformation,
 * manifestations, and any unidentified text.
 *
 * @param {string} inputText - The structured text representing the idea.
 * @returns {Object} An object with the following properties:
 *                   - type: {string} The type of the idea.
 *                   - headline: {string} The headline of the idea.
 *                   - transformation: {string} The transformation description.
 *                   - manifestations: {string[]} An array of manifestation descriptions.
 *                   - unidentified: {string} Any text that does not match the predefined categories.
 */
const parseId8Message = (inputText) => {
  if (!inputText || typeof inputText !== 'string')
    return { type: '', headline: '', transformation: '', manifestations: [], unidentified: '' };

  const extractAndRemove = (pattern, text) => {
    const match = text.match(pattern);
    if (!match) return { extracted: '', remaining: text };
    return { extracted: match[1].trim(), remaining: text.replace(match[0], '').trim() };
  };

  let remainingText = inputText;

  const { extracted: type, remaining: afterType } = extractAndRemove(/Idea type:\s*(.*)/i, remainingText);
  const { extracted: headline, remaining: afterHeadline } = extractAndRemove(/Idea headline:\s*(.*)/i, afterType);
  const { extracted: transformation, remaining: afterTransformation } = extractAndRemove(
    /Transformation:\s*([\s\S]*?)(?=\n|$)/i,
    afterHeadline,
  );
  const { extracted: manifestationsText, remaining: unidentified } = extractAndRemove(
    /Manifestation:\s*([\s\S]*)/i,
    afterTransformation,
  );

  return { type, headline, transformation, manifestationsText, unidentified };
};

export default parseId8Message;
